export default "__VITE_ASSET__DYv66$TX__"